import type {
  CampaignProduct,
  CampaignProductVariant,
} from '@bvengineering/cas-member-gateway-service-client';

export const PRODUCT_STATE = {
  RESERVED: 'reserved',
  CLAIMED: 'claimed',
} as const;

export const variantInStock = (v: CampaignProductVariant): boolean =>
  (v.remainingSampleCount ?? 0) > 0;

export const hasClaimedProduct = (userProducts: CampaignProduct[] | null | undefined): boolean =>
  userProducts?.some(
    (product) => !!product.claimedDate || product.state?.toLowerCase() === PRODUCT_STATE.CLAIMED
  ) ?? false;

export const findReservedUserProduct = (
  userProducts: CampaignProduct[] | null | undefined
): CampaignProduct | null =>
  userProducts?.find((p) => p.state?.toLowerCase() === PRODUCT_STATE.RESERVED && !p.claimedDate) ??
  null;
